import {
  GET_CURRENT_USER_FAILURE,
  GET_CURRENT_USER_START,
  GET_CURRENT_USER_SUCCESS,
} from 'constants/action-types/user/currentUser';
import { UPDATE_ACCOUNT_SUCCESS } from 'constants/action-types/user/updateUser';
import {
  isLoanAdmin,
  isLoanOfficer,
  isSupportAdmin,
  isSupportUser,
} from 'helpers/checkRoles';

export const isSSA = roles =>
  roles.find(({ name }) => name === 'ssa');

const filterActiveRoles = roles =>
  (roles || []).filter(role => role.UserRole?.status !== 'inactive');

export default (state, { type, payload }) => {
  switch (type) {
    case GET_CURRENT_USER_START:
      return {
        ...state,
        currentUser: {
          ...state.currentUser,
          loading: true,
          error: null,
        },
      };
    case GET_CURRENT_USER_SUCCESS: {
      const activeRoles = filterActiveRoles(payload.data?.roles);
      return {
        ...state,
        currentUser: {
          ...state.currentUser,
          details: {
            ...payload.data,
            roles: activeRoles,
            isSSA: isSSA(activeRoles),
            isSupportAdmin: isSupportAdmin(activeRoles),
            isLoanAdmin: isLoanAdmin(activeRoles),
            isLoanOfficer: isLoanOfficer(activeRoles),
            isSupportUser: isSupportUser(activeRoles),
          },
          loading: false,
        },
      };
    }
    case GET_CURRENT_USER_FAILURE:
      return {
        ...state,
        currentUser: {
          ...state.currentUser,
          loading: false,
          error: payload,
        },
      };
    case UPDATE_ACCOUNT_SUCCESS: {
      const activeRoles = filterActiveRoles(payload.roles);
      return {
        ...state,
        currentUser: {
          ...state.currentUser,
          details: {
            ...payload,
            roles: activeRoles,
            isSSA: isSSA(activeRoles),
            isSupportAdmin: isSupportAdmin(activeRoles),
            isLoanAdmin: isLoanAdmin(activeRoles),
            isLoanOfficer: isLoanOfficer(activeRoles),
            isSupportUser: isSupportUser(activeRoles),
          },
        },
      };
    }
    default:
      return null;
  }
};
